import React from "react";

export const defaultSidebarItems = [
  {
    label: "Consulta",
    href: "/",
    icon: (
      <img src="/images/Look.svg" width={32} height={32.5} alt="Consulta" />
    ),
  },
];
